import { render, staticRenderFns } from "./DuplicateMedia.vue?vue&type=template&id=312b76c5&"
import script from "./DuplicateMedia.vue?vue&type=script&lang=js&"
export * from "./DuplicateMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports